module.exports = __webpack_public_path__ + "static/profile-f0975c5e9328f5e4d4a0b656fb403f9e.png";